// extracted by mini-css-extract-plugin
export default {"_":"ReducedMotionIcon____osYQm","fade":"ReducedMotionIcon_fade__PP1BG","moreFade":"ReducedMotionIcon_moreFade__fSp0W"};